<template>
  <div class="company-app-group">
    <div class="title">
      应用分组
    </div>
    <div class="right">
      <base-button @click="addAppGroup">
        新建分组
      </base-button>
      <base-button type="primary" @click="saveGroup">
        保存
      </base-button>
    </div>
    <div v-if="!showMenuList" v-loading="!showMenuList" class="empty"></div>
    <section class="content-box">
      <section class="menu-list-wrap no-bar">
        <div class="list-title">
          已分组应用
        </div>
        <div v-if="appGroup.length === 0" class="group-empty">暂无应用分组</div>
        <draggable v-else group="group" v-model="appGroup" :animation="100">
          <div v-for="(group, groupIndex) in appGroup" :key="group.groupId" class="group-box">
            <menu-item
              type="group"
              :data="group"
              @delete="deleteGroup(group, groupIndex)"
              editable
              collapsed
              @collapse="collapse(groupIndex)"
              :fold="fold[groupIndex]"
              @dragenter.native="changeFold(groupIndex)"
            ></menu-item>
            <draggable
              v-if="!fold[groupIndex]"
              group="group-item"
              v-model="group.appList"
              :animation="100"
            >
              <menu-item
                v-for="(app, appIndex) in group.appList"
                type="app"
                :data="app"
                :key="app.id"
                @delete="removeApp(group, app, appIndex)"
                class="app-row"
              ></menu-item>
            </draggable>
          </div>
        </draggable>
      </section>
      <section class="menu-list-wrap no-bar">
        <div class="list-title">未分组应用</div>
        <el-input
          v-model="searchText"
          size="small"
          placeholder="应用名称"
          clearable
          prefix-icon="el-icon-search"
          style="margin-bottom: 6px;"
          @input="search"
        ></el-input>
        <draggable group="group-item" v-model="filterUngrouped" :animation="100">
          <menu-item
            v-for="sheet in filterUngrouped"
            type="sheet"
            :key="sheet.sheetId"
            :data="sheet"
            :deletable="false"
            style="padding-left: 24px"
          ></menu-item>
        </draggable>
      </section>
    </section>
  </div>
</template>
<script>
import MenuItem from "../Layout/MenuItem"
import BaseButton from "@/components/UIComponents/Button"
import draggable from "vuedraggable"
import { getAppGroupList, saveAppGroupList } from "@/api/user"
import { loadingService } from "@/utils/ui"
import { randomString, stringIncludes } from "@/utils/common"
import { getAppList } from "@/api/userCenter/app"
export default {
  name: "companyAppGroup",
  components: { MenuItem, BaseButton, draggable },
  data() {
    return {
      appMap: {},
      apps: [],
      groupAppIds: [],
      appGroup: [],
      ungrouped: [],
      showMenuList: false,
      fold: [],
      searchText: "",
      filterUngrouped: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    async refresh() {
      let res = await getAppList("ALL")
      this.apps = res
      this.apps.forEach(item => {
        this.appMap[item.id] = { name: item.name, shared: item.shared }
      })
      res = await getAppGroupList()
      if (res) {
        this.appGroup = res.map((t, index) => {
          let list = []
          t.appIdList.forEach(appId => {
            if (this._.keys(this.appMap).includes(appId)) {
              this.groupAppIds.push(appId)
              list.push({
                id: appId,
                name: this.appMap[appId].name,
                shared: this.appMap[appId].shared
              })
            }
          })
          t.appList = list
          t.groupId = randomString(10)
          index === 0 ? this.fold.push(false) : this.fold.push(true)
          return t
        })
      }
      this.ungrouped = this.apps
        .filter(app => !this.groupAppIds.includes(app.id))
        .map(app => {
          return { id: app.id, name: this.appMap[app.id].name, shared: this.appMap[app.id].shared }
        })
      this.filterUngrouped = this.ungrouped
      this.showMenuList = true
    },
    verify() {
      let groupNames = this.appGroup.map(i => i.name)
      let unique = new Set(groupNames)
      if (groupNames.length !== unique.size) {
        this.$message.error("存在重复的分组名，请修改后再提交！")
        return false
      }
      return true
    },
    addAppGroup() {
      this.appGroup.push({
        groupId: randomString(10),
        appList: [],
        name: "新建分组"
      })
    },
    saveGroup() {
      if (!this.verify()) return
      let loadingInstance = loadingService({ text: "请求中" })
      let appGroups = this.appGroup.map(group => {
        return {
          name: group.name,
          appIdList: group.appList.map(app => app.id)
        }
      })
      return saveAppGroupList(appGroups)
        .then(res => {
          if (res.data.code !== 0) return this.$message.error("保存失败，请重试！")
          this.$message.success("工作表分组更新成功！")
        })
        .finally(() => loadingInstance.close())
    },
    deleteGroup(group, groupIndex) {
      if (group.appList.length > 0) return this.$message.error("分组内还存在应用时不可删除！")
      this.appGroup.splice(groupIndex, 1)
    },
    removeApp(group, app, appIndex) {
      group.appList.splice(appIndex, 1)
      this.ungrouped.push(app)
      this.search()
    },
    changeFold(groupIndex) {
      if (this.fold[groupIndex]) {
        this.collapse(groupIndex)
      }
    },
    collapse(groupIndex) {
      this.$set(this.fold, groupIndex, !this.fold[groupIndex])
    },
    search() {
      this.filterUngrouped = this.ungrouped.filter(i => stringIncludes(i.name, this.searchText))
    }
  }
}
</script>
<style lang="scss" scoped>
.company-app-group {
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .right {
    display: flex;
    float: right;
    margin: 10px 20px 0 20px;
  }
  .empty {
    height: calc(100vh - 52px - 60px);
    width: 100%;
  }
  .content-box {
    display: flex;
    .group-empty {
      text-align: center;
      height: 80px;
      line-height: 80px;
      color: #757575;
      font-size: 13px;
    }
    .menu-list-wrap {
      padding: 0 30px 20px 16px;
      height: calc(100vh - 52px - 60px);
      width: 50%;
      max-width: 700px;
      overflow: auto;
      box-sizing: border-box;
      .list-title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .group-box {
        border-bottom: 1px solid #fff;
      }
    }
    .app-row {
      padding-left: 33px;
    }
  }
}
.company-app-group .content-box {
  width: 100%;
}
</style>
